// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Button, Slide } from '@mui/material';
import { useAppSelector } from '@advisor-app/store/store';
import { useAppNavigate } from '@advisor-app/hooks';
import { useMemo } from 'react';
import { selectExpirationDate } from '@shared/data-access/slices/user';
import { useTranslation } from 'react-i18next';

export const BarTrialPeriod = () => {
  const navigate = useAppNavigate();
  const { t } = useTranslation();

  const expirationDate = useAppSelector(selectExpirationDate);
  const today = new Date().getTime();

  const daysLeft = useMemo(() => {
    if (!expirationDate) return 0;
    return Math.floor((expirationDate - today) / 86400000);
  }, [expirationDate, today]);

  return daysLeft > 15 ? null : (
    <Slide direction="down" in={!!expirationDate} mountOnEnter unmountOnExit>
      <div
        className="flex justify-center bg-positive/20 p-3"
        data-testid="container-trial"
      >
        <div className="flex items-center justify-center">
          <p className="mr-2 text-subtitle">
            <strong className="mr-2 text-[20px]">
              {daysLeft < 0 ? 0 : daysLeft}{' '}
              {t('auth.trial-period.days-left', { ns: 'auth' })}
            </strong>
            {''} {t('auth.trial-period.of-current-license', { ns: 'auth' })}
          </p>
          <Button
            className="!rounded-md p-2 !font-bold"
            onClick={() => navigate('/account')}
            data-testid="suscribe-button"
          >
            {t('auth.trial-period.manage-license', { ns: 'auth' })}
          </Button>
        </div>
      </div>
    </Slide>
  );
};
